module.exports = __webpack_public_path__ + "firasans-lightitalic-webfont.2e783211cefbdda79348.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/sherr/Desktop/bsf-website/src/assets/fonts/firasans-lightitalic-webfont.woff2
// module id = ../../../../../src/assets/fonts/firasans-lightitalic-webfont.woff2
// module chunks = 1